import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

declare var $:any;

declare var gtag;


@Component({
  selector: 'seguros-personas-header-component',
  templateUrl: './seguros-personas-header.component.html',
  styleUrls: ['./seguros-personas-header.component.scss']
})
export class SegurosPersonasHeaderComponent implements OnInit {

  @Input('HeaderHtml')HeaderHtml;
  @Input('menuHeaderHtml') menuHeaderHtml;
  @Input('BotonesDeSlides')BotonesDeSlides;
  @Input('menuFooterHtml')menuFooterHtml;

  @Output() uuid: EventEmitter<any> = new EventEmitter();
  @Output() buscar: EventEmitter<any> = new EventEmitter();
  

  constructor() { 
    
  }

  ngOnInit() {
    $(".layer").click(function (event) {
      $("#lg_slide").fadeIn(500, function () {
      });
    });
  }

  redireccionarAPaginaExistente(uuid){
    
    this.uuid.emit(uuid);

       gtag('config', 'UA-118311338-3',{
        'page' : '/seguros-personas/'+uuid, 
        'page-path':'/seguros-personas/'+uuid,
        'page_title' : '/seguros-personas/'+uuid,
        'page_location' : '/seguros-personas/'+uuid
        });


    $(".lg-menu").fadeOut();
    // $("#lg_slide").fadeOut();
    $("#lg_slide").removeClass("active");
  }

  search(){
   this.buscar.emit(true);
   $(".lg-menu").fadeOut();
    // $("#lg_slide").fadeOut();
    // $("#lg_slide").removeClass("active");
    // $(".c-body").removeClass("overflow-hidden");
   
  }

}
